export default __webpack_public_path__ + "file/Fiche-ES-Produit-Puroak-Mini-Staves.asset.91b8ec85.pdf";